import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import AdminCustomersApi from "./api/adminCustomersApi";
import { AdminCustomersState, CustomersQuery, CustomersQueryParameter } from "./models/AdminCustomersModels";

export const getCustomers = createAsyncThunk(
  "adminCustomers/getCustomers",
  async (query: CustomersQuery) => {
    return AdminCustomersApi.getCustomers(query);
  }
);

export const changeCustomer = createAsyncThunk(
  "adminCustomers/changeCustomer",
  async ({ id, model }: any) => {
    return AdminCustomersApi.changeCustomer(id, model);
  }
);

export const changeCustomerStatus = createAsyncThunk(
  "adminCustomers/changeCustomerStatus",
  async ({ id, isDisabled }: any) => {
    return AdminCustomersApi.changeCustomerStatus(id, isDisabled);
  }
);

export const deleteCustomer = createAsyncThunk(
  "adminCustomers/deleteCustomer",
  async (id: string) => {
    return AdminCustomersApi.deleteCustomer(id);
  }
);

const initialState: AdminCustomersState = {
  query: {
    search: undefined,
    sortBy: CustomersQueryParameter.CreatedDate,
    sortDesc: true,
    pageNo: 1,
    pageSize: 20
  },
  customers: undefined,
  customer: undefined,
  loading: false,
  success: undefined,
  error: undefined
};

const adminCustomersSlice = createSlice({
  name: "adminCustomers",
  initialState: initialState,
  reducers: {
    changeQuery: (state, action) => {
      state.query = action.payload;
    },
    selectCustomer: (state, action) => {
      state.customer = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    }
  },
  extraReducers: builder => {
    builder
      .addCase(getCustomers.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCustomers.fulfilled, (state, { payload }) => {
        state.customers = payload;
        state.loading = false;
      })
      .addCase(getCustomers.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(changeCustomerStatus.pending, (state) => {
        state.loading = true;
      })
      .addCase(changeCustomerStatus.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(changeCustomerStatus.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });

    builder
      .addCase(deleteCustomer.pending, (state) => {
        state.loading = true;
      })
      .addCase(deleteCustomer.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(deleteCustomer.rejected, (state, { error }) => {
        state.error = error;
        state.loading = false;
      });
  }
});

export const {
  changeQuery,
  selectCustomer,
  setSuccess
} = adminCustomersSlice.actions;

export default adminCustomersSlice.reducer;